import React from 'react';
import {
    DetailsTable,
    DetailsRow,
} from 'components/interface/DetailsTable/DetailsTable';
import Currency from 'components/interface/currency/Currency';
import { Button } from 'components/Button';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme, params, classes) => ({
    actionWrapper: {
        width: '100%',
        marginTop: theme.spacing(2),
    },
}));

export default function InformationComponent({
    data,
    loading,
    onSignBookingConfirmation,
}) {
    const { classes } = useStyles();
    const shouldSignBookingConfirmation =
        data?.bookingConfirmation?.requiresSignature === true &&
        data?.bookingConfirmation?.document?.signedBySupplier === false;

    return (
        <>
            <DetailsTable title='Information' isMobile>
                <DetailsRow
                    name={'Land'}
                    value={data?.country?.name || '-'}
                    loading={loading}
                    noSelect
                    isMobile
                />
                <DetailsRow
                    name={'Region'}
                    value={data?.county?.name || '-'}
                    loading={loading}
                    noSelect
                    isMobile
                />
                <DetailsRow
                    name={'Bruttoersättning'}
                    value={
                        <Currency
                            value={
                                data?.financials?.overview?.summary
                                    ?.grossCompensation
                            }
                            currencyCode={data?.country?.currencyCode}
                        />
                    }
                    loading={loading}
                    noSelect
                    isMobile
                />
            </DetailsTable>
            {shouldSignBookingConfirmation ? (
                <div className={classes.actionWrapper}>
                    <Button
                        variant='primary'
                        onClick={onSignBookingConfirmation}
                        fullWidth>
                        Signera bokningsbekräftelse
                    </Button>
                </div>
            ) : null}
        </>
    );
}
